import * as React from 'react';
import TrackableComponent from 'components/TrackableComponent/TrackableComponent';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
class AutosuggestTrackableTemplate extends React.Component {
    constructor() {
        super(...arguments);
        this.trackableItem = null;
        this.trackItemImpression = () => {
            const intersectionObserverRootMargin = '0px 0px 0px 0px';
            const tracking = get(this.props, 'tracking');
            !isEmpty(tracking) &&
                this.props.trackAutosuggestItemImpression(tracking, this.trackableItem, intersectionObserverRootMargin);
        };
        this.trackableItemRef = (c) => {
            this.trackableItem = c;
        };
    }
    componentDidMount() {
        this.trackItemImpression();
    }
    componentDidUpdate() {
        try {
            this.props.untrackImpression(this.trackableItem);
        }
        catch (_) {
            /* tslint:disable:no-empty */
        }
        this.trackItemImpression();
    }
    render() {
        return <div ref={this.trackableItemRef}>{this.props.children}</div>;
    }
}
export default TrackableComponent(AutosuggestTrackableTemplate);
